import isEmpty from 'lodash/isEmpty'
import dotProp from 'dot-prop-immutable'

export const assignIndex = (image, index) => ({ ...image, index })

export const removeSystem = isTrue => image => image.isCustom === !isTrue

export const assignSelection = state => image => ({
  ...image,
  isSelected: image.src === dotProp.get(state, 'project.background.src', ''),
  isActive: image.index === dotProp.get(state, 'wallpapers.selectedIndex', false),
})

export const isGauged = image => ({
  ...image,
  isGauged: !isEmpty(image.calibration),
})



// WEBPACK FOOTER //
// ./src/containers/CollectionWallpapers/utilities.js